import http from '../httpService';
import * as Axios from 'axios';

export const getAllExternalizationDocumentTemplates = () => {
  return http.get(`/externalization-document-templates`);
};

export function deleteExternalizationDocumentTemplates(id) {
  return http.delete(`/externalization-document-templates/${id}`);
}
export function updateExternalizationDocumentTemplates(templateId,payload) {
  return http.put(`/externalization-document-templates/${templateId}`, payload);
}

export function createExternalizationDocumentTemplates(formData) {
  return http.post('/externalization-document-templates', formData,{'Content-Type': 'multipart/form-data'});
}
export function downloadExternalizationFile(externalizationAttachmentId, fileName) {
  return Axios({
    url: `externalizations-attachment/${externalizationAttachmentId}/download`,
    method: 'get',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  });
}

export function getExternalizationFile(externalizationAttachmentId) {
  return Axios({
    url: `externalizations-attachment/${externalizationAttachmentId}/download`,
    method: 'get',
    responseType: 'blob',
  });
}